import { motion, useReducedMotion } from 'framer-motion';

export default function Inspo() {
    const shouldReduceMotion = useReducedMotion();

    return (
        <div className="home-page">
            <motion.div
                className="bio"
                initial={shouldReduceMotion ? false : { opacity: 0, y: -36 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                    duration: shouldReduceMotion ? 0 : 0.55,
                    ease: [0.22, 1, 0.36, 1],
                }}
            >
                <a
                    href="https://p5aholic.me/"
                    target="_blank"
                    rel="noreferrer"
                    className="inspo-link"
                >
                    Inspired by Keita·Yamada, Designer & Developer
                </a>
            </motion.div>
        </div>
    );
}
